import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useLanguage } from "../i18n";

export default function PaymentCancel() {
  const { t } = useLanguage();
  return (
    <div data-testid="payment-cancel-page" className="px-4 max-w-2xl mx-auto py-32 text-center">
      <XCircle className="w-12 h-12 mx-auto text-[var(--text-muted)]" />
      <h1 className="font-display font-extrabold text-4xl tracking-tight mt-6">{t("pay.cancelled")}</h1>
      <p className="mt-4 text-[var(--text-secondary)]">{t("pay.cancelledSub")}</p>
      <Link to="/destinations" data-testid="payment-cancel-back" className="inline-block mt-10 rounded-full bg-[var(--bg-dark)] text-[var(--text-on-dark)] px-8 py-3 font-mono-t text-xs uppercase tracking-[0.2em] hover:bg-[var(--accent-terracotta)] transition-colors">
        {t("pay.continue")}
      </Link>
    </div>
  );
}
